import { create, defaulted, Describe, nullable, optional, string, type } from 'superstruct';

import { JsmContactConfig } from '~modules/jsm-contact/model/Config';

export const JsmContactConfigValidator: Describe<Required<JsmContactConfig>> = defaulted(
  type({
    dataKey: optional(nullable(string())),
    portalBaseUrl: optional(nullable(string())),
    requestTypeId: optional(nullable(string())),
  }),
  {
    dataKey: '',
    portalBaseUrl: '',
    requestTypeId: '',
  },
);

export default (rawConfig: string): JsmContactConfig => {
  let config: Partial<JsmContactConfig>;
  try {
    config = JSON.parse(rawConfig);
  } catch (_error) {
    config = {};
  }

  return create(config, JsmContactConfigValidator);
};
